import {useTranslation as useI18nextTranslation} from 'react-i18next';
import {NamespaceType, TranslationFunction} from '#common/i18n/types';

type UseTranslationResult = {
  translate: TranslationFunction;
};

export function useTranslation(namespaces?: NamespaceType | NamespaceType[]): UseTranslationResult {
  const {t} = useI18nextTranslation(namespaces, {useSuspense: true});
  return {
    translate: t,
  };
}
